import React, { useEffect, useRef } from "react";

const RestrictionModal = ({ show, onHide, title, message, buttonText, secondaryButtonText, onSecondaryClick, userName }) => {
  const overlayRef = useRef(null);
  const nameToDisplay = userName && userName !== "User" ? userName : "User";
  const displayMessage = message ? message.split("{userName}").join(nameToDisplay) : "";

  useEffect(() => {
    const handleKeyDown = (e) => { if (e.key === "Escape") onHide(); };
    if (show) document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [show, onHide]);

  if (!show) return null;

  return (
    <div
      ref={overlayRef}
      onClick={(e) => { if (e.target === overlayRef.current) onHide(); }}
      style={{
        position: "fixed", inset: 0,
        background: "rgba(0,0,0,0.45)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1050, padding: "1rem",
        animation: "fadeIn 0.2s ease",
      }}
    >
      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(16px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }
        .rm-close:hover  { background: #f3f4f6; }
        .rm-secondary:hover { background: #f3f4f6; }
        .rm-primary:hover   { opacity: 0.88; transform: scale(0.99); }
      `}</style>

      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="rm-title"
        style={{
          background: "#fff",
          borderRadius: "16px",
          border: "0.5px solid rgba(0,0,0,0.12)",
          width: "100%", maxWidth: "440px",
          overflow: "hidden",
          animation: "slideUp 0.35s cubic-bezier(0.16,1,0.3,1)",
        }}
      >
        {/* Header */}
        <div style={{ padding: "1.5rem 1.5rem 1rem", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={{
              width: "38px", height: "38px", borderRadius: "10px",
              background: "#fffbeb", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <p id="rm-title" style={{ fontSize: "15px", fontWeight: 500, color: "#111", margin: 0, lineHeight: 1.3 }}>
              {title}
            </p>
          </div>

          <button
            className="rm-close"
            onClick={onHide}
            aria-label="Close"
            style={{
              width: "28px", height: "28px", borderRadius: "6px",
              border: "none", background: "transparent", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0, color: "#6b7280", transition: "background 0.15s ease",
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "0 1.5rem 1.25rem" }}>
          <p style={{ fontSize: "14px", color: "#6b7280", lineHeight: 1.65, margin: 0, whiteSpace: "pre-line" }}>
            {displayMessage}
          </p>
        </div>

        {/* Footer */}
        <div style={{
          padding: "1rem 1.5rem 1.25rem",
          borderTop: "0.5px solid rgba(0,0,0,0.08)",
          display: "flex", justifyContent: "flex-end", gap: "8px",
        }}>
          {secondaryButtonText && (
            <button
              className="rm-secondary"
              onClick={onSecondaryClick || onHide}
              // style={{
              //   padding: "7px 14px", fontSize: "13px", fontWeight: 500,
              //   borderRadius: "8px", border: "0.5px solid rgba(0,0,0,0.15)",
              //   background: "transparent", color: "#374151", cursor: "pointer",
              //   transition: "background 0.15s ease",
              // }}
            >
              {secondaryButtonText}
            </button>
          )}
          <button
            className="rm-primary"
            onClick={onHide}
            style={{
              padding: "7px 16px", fontSize: "13px", fontWeight: 500,
              borderRadius: "8px", border: "none",
              background: "#0030B6", color: "#fff", cursor: "pointer",
              transition: "opacity 0.15s ease, transform 0.1s ease",
            }}
          >
            {buttonText || "Got it"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestrictionModal;